/**
 * Asset path utilities for generating URLs to static and dynamic assets
 */

/**
 * Generate URL for chemical structure images
 * @param {string} filename - The image filename
 * @returns {string} Full URL to the image
 */
export function getCoaImageUrl(filename) {
  if (!filename) return '';
  if (filename.startsWith('http')) return filename;
  const apiBase = process.env.REACT_APP_API_URL || '/api';
  const serverBase = apiBase.replace(/\/api$/, '');
  return `${serverBase}/uploads/coa-images/${filename}`;
}

/**
 * Generate URL for product images
 * @param {string} filename - The image filename
 * @returns {string} Full URL to the image
 */
export function getProductImageUrl(filename) {
  if (!filename) return '';
  
  if (filename.startsWith('http')) {
    return filename;
  }
  
  return `/images/products/${filename}`;
}

/**
 * Generate URL for company logo
 * @param {string} filename - The logo filename (optional)
 * @returns {string} Full URL to the logo
 */
export function getLogoUrl(filename = 'prasilabs-logo.png') {
  if (filename.startsWith('http')) {
    return filename;
  }
  
  return `/${filename}`;
}
